module.exports = __webpack_public_path__ + "static/Custom-UI-0b9de4a67e93db9c8a015aa9638dbb12.png";